function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { cx } from '@emotion/css';
import React from 'react';
import { ArrowUpOutlinedIcon, SearchOutlinedIcon } from "../Icons";
import { dividingLine, searchTreeStyle, prefix as searchTreeClass, hideClass } from "./index.style";
import { createSearchTreeModel, noop } from "./createSearchTreeModel";
import EmptyContent from "./EmptyContent";
import Input from "../Input";
import Tree from "../Tree";
import useThemeProps from "../../hooks/useThemeProps";
import { useOnUpdate } from "../../hooks/useOnUpdate";
import { useFreshStaticValue } from "../../hooks/useFreshStaticValue";
import { useFreshFunction } from "../../hooks/useFreshFunction";
export var SearchTreeContext = /*#__PURE__*/React.createContext(null);
var SearchTree = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var treeData = _ref.treeData,
      lazy = _ref.lazy,
      header = _ref.header,
      defaultCheckedKeys = _ref.defaultCheckedKeys,
      checkedKeys = _ref.checkedKeys,
      selectedKeys = _ref.selectedKeys,
      defaultSelectedKeys = _ref.defaultSelectedKeys,
      defaultExpandAll = _ref.defaultExpandAll,
      defaultExpandedKeys = _ref.defaultExpandedKeys,
      disabled = _ref.disabled,
      showLine = _ref.showLine,
      showIcon = _ref.showIcon,
      checkable = _ref.checkable,
      strict = _ref.strict,
      multiple = _ref.multiple,
      expandAnimation = _ref.expandAnimation,
      useEllipsis = _ref.useEllipsis,
      onCheck = _ref.onCheck,
      onExpand = _ref.onExpand,
      onSelect = _ref.onSelect,
      onNodeClick = _ref.onNodeClick,
      customFooter = _ref.customFooter,
      placeholder = _ref.placeholder,
      value = _ref.value,
      maxLength = _ref.maxLength,
      status = _ref.status,
      onKeyDown = _ref.onKeyDown,
      onPressEnter = _ref.onPressEnter,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      prefix = _ref.prefix,
      _ref$inputProps = _ref.inputProps,
      inputProps = _ref$inputProps === void 0 ? {} : _ref$inputProps,
      size = _ref.size,
      _style = _ref.style,
      customClass = _ref.className,
      autoExpandAfterSearching = _ref.autoExpandAfterSearching,
      _treeStyle = _ref.treeStyle,
      ignoreCase = _ref.ignoreCase,
      onSearch = _ref.onSearch,
      debounceTime = _ref.debounceTime,
      newSearchMethod = _ref.newSearchMethod,
      emptyContent = _ref.emptyContent;

  /* format */
  if (typeof debounceTime !== 'number' || debounceTime < 0 || Number.isNaN(debounceTime)) {
    debounceTime = 0;
  }

  var theme = useThemeProps();
  var matchedKeys = React.useRef([]);

  var _React$useState = React.useState(-1),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      currentMatchedKeyIndex = _React$useState2[0],
      setCurrentMatchedKeyIndex = _React$useState2[1]; // index
  // -1 表示没搜索


  var _React$useState3 = React.useState(-1),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      totalMatchedCount = _React$useState4[0],
      setTotalMatchedCount = _React$useState4[1]; // length


  var _React$useState5 = React.useState(''),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      inputValue = _React$useState6[0],
      setInputValue = _React$useState6[1];

  var _React$useState7 = React.useState(0),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      scrollTop = _React$useState8[0],
      setScrollTop = _React$useState8[1];

  var treeRef = React.useRef(null);
  var inputRef = React.useRef(null);
  var onChange = React.useCallback(function (e) {
    var text = e.target.value;
    setInputValue(text);
  }, []);
  var search = useFreshFunction(function () {
    var findKeyWord = searchTreeContext.findKeyWord,
        highLight = searchTreeContext.highLight,
        expandNode = searchTreeContext.expandNode,
        clearHighLight = searchTreeContext.clearHighLight,
        titleNodeMap = searchTreeContext.titleNodeMap,
        text = searchTreeContext.matchText;
    var lastMatchedKeys = matchedKeys.current;
    clearHighLight(lastMatchedKeys);

    if (text) {
      var _findKeyWord = findKeyWord(text, staticConfig.current.ignoreCase, staticConfig.current.newSearchMethod),
          keys = _findKeyWord.keys,
          totalCount = _findKeyWord.totalCount; // 只有这里更新 matchedKeys，更新后再用


      matchedKeys.current = keys;
      var prev = currentMatchedKeyIndex;

      if (keys.length === 0 || totalCount === 0) {
        searchTreeContext.currentKey = '';
        setCurrentMatchedKeyIndex(-1);
        setTotalMatchedCount(totalCount); // 搜不到的时候保持展开, 下次收起来

        matchedKeys.current = lastMatchedKeys;
        return;
      } else if (prev === -1 || prev > totalCount - 1) {
        switchHighLightNode(prev, 0, totalCount);
        setCurrentMatchedKeyIndex(0);
      } else {
        // scroll to element
        switchHighLightNode(prev, prev, totalCount);
      } // 可能被移除了


      resetExpand(lastMatchedKeys); // 全部展开时减少重复计算

      var cache = {};

      var hasDone = function hasDone(model) {
        var key = model.treeNode.key;

        if (!cache[key]) {
          cache[key] = true;
          return false;
        } else {
          return true;
        }
      }; // 在渲染子节点之前，拿到最新的当前 key


      keys.forEach(function (key) {
        if (staticConfig.current.autoExpandAfterSearching || titleNodeMap[key]) {
          highLight(key, Boolean(titleNodeMap[key]));
          expandNode(key, {
            animation: false,
            hasDone: hasDone
          });
        }
      });
      setTotalMatchedCount(totalCount);
    } else {
      setScrollTop(0);
      setCurrentMatchedKeyIndex(-1);
      setTotalMatchedCount(-1);
      searchTreeContext.currentKey = '';
    }
  });

  var handleSearchEvent = function handleSearchEvent() {
    search();
    var text = searchTreeContext.matchText;
    var onSearch = staticConfig.current.onSearch;
    onSearch && onSearch(text);
  };

  var resetExpand = React.useCallback(function (unsafeLastMatchedKeys) {
    // close
    var treeModel = searchTreeContext.treeModel,
        parseKey = searchTreeContext.parseKey;

    if (treeModel) {
      var getModel = treeModel.getModel,
          expandedKeys = treeModel.expandedKeys;

      var propagation = function propagation(m) {
        if (treeModel.isRoot(m.treeNode.key)) {
          return;
        }

        var isChildStillExpanded = m.snapshot.expandedCount > 0; // 关闭没有展开的 child？

        if (!isChildStillExpanded) {
          var treeNode = m.treeNode;
          m.trigger({
            type: 'expand',
            expanded: false,
            animation: false,
            currentItem: treeNode,
            model: getModel(m.pKey)
          }, propagation);
        }
      };

      var _iterator = _createForOfIteratorHelper(unsafeLastMatchedKeys),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var key = _step.value;

          var _parseKey = parseKey(key),
              _parseKey2 = _slicedToArray(_parseKey, 1),
              nodeKey = _parseKey2[0];

          var model = getModel(nodeKey);
          if (!model) continue;

          if (treeModel.isLeaf(model) || expandedKeys.has(nodeKey)) {
            model.trigger({
              type: 'expand',
              expanded: false,
              animation: false,
              currentItem: model.treeNode,
              model: getModel(model.pKey)
            }, propagation);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  var getLatestLabelStatus = React.useCallback(function (prev, newValue, total) {
    var p = prev;
    var n = newValue;
    var lastHighLight, currentHighLight;
    var currentKey = '';

    if (matchedKeys.current.length === 0) {
      return {
        currentKey: currentKey,
        lastHighLight: function lastHighLight() {},
        currentHighLight: function currentHighLight() {}
      };
    }

    for (var i = 0; i < matchedKeys.current.length; i++) {
      var k = matchedKeys.current[i];
      var _searchTreeContext$ma = searchTreeContext.matched[k],
          count = _searchTreeContext$ma.count,
          children = _searchTreeContext$ma.children,
          indexMap = _searchTreeContext$ma.indexMap;

      if (n >= count) {
        n -= count;
      } else if (!currentHighLight) {
        currentKey = k;
        currentHighLight = children[indexMap[n]].highLight;
      }

      if (currentHighLight) {
        break;
      }
    }

    if (prev > total - 1) {
      lastHighLight = noop;
    } else {
      for (var _i2 = 0; _i2 < matchedKeys.current.length; _i2++) {
        var _k = matchedKeys.current[_i2];
        var _searchTreeContext$ma2 = searchTreeContext.matched[_k],
            _count = _searchTreeContext$ma2.count,
            _children = _searchTreeContext$ma2.children,
            _indexMap = _searchTreeContext$ma2.indexMap;

        if (p >= _count) {
          p -= _count;
        } else if (!lastHighLight) {
          if (p > -1) {
            lastHighLight = _children[_indexMap[p]].highLight;
          } else {
            lastHighLight = noop;
          }
        }

        if (lastHighLight) {
          break;
        }
      }
    }

    return {
      currentHighLight: currentHighLight,
      lastHighLight: lastHighLight,
      currentKey: searchTreeContext.createKey(currentKey, String(searchTreeContext.matched[currentKey].indexMap[n]))
    };
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  var switchHighLightNode = React.useCallback(function (prev, newValue, total) {
    var _getLatestLabelStatus = getLatestLabelStatus(prev, newValue, total),
        currentHighLight = _getLatestLabelStatus.currentHighLight,
        currentKey = _getLatestLabelStatus.currentKey,
        lastHighLight = _getLatestLabelStatus.lastHighLight;

    searchTreeContext.currentKey = currentKey;
    lastHighLight(false);
    currentHighLight(true);
    scrollToCurrentHighLightNode();
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  var scrollToCurrentHighLightNode = React.useCallback(function () {
    var treeModel = searchTreeContext.treeModel,
        layout = searchTreeContext.layout,
        expandNode = searchTreeContext.expandNode,
        currentKey = searchTreeContext.currentKey,
        parseKey = searchTreeContext.parseKey;

    var _parseKey3 = parseKey(currentKey),
        _parseKey4 = _slicedToArray(_parseKey3, 1),
        nodeKey = _parseKey4[0];

    if (treeModel && layout) {
      // 节点处于折叠状态，未被渲染
      // ...
      // 展开
      expandNode(nodeKey, {
        animation: false
      }); // 浏览器渲染时 父节点 offsetHeight 未被完全撑开，可滚动的容器高度不正确，所以需要延迟执行

      setTimeout(function () {
        // scroll
        var h = -1 * treeModel.getRoot().layout.height;
        treeModel.dfs(treeModel.getRoot(), function (m) {
          if (m.treeNode.key === nodeKey) {
            return false;
          }

          h += m.layout.height; // header 没有 expanded

          if (m.getExpanded(m.treeNode.key) || m.pKey === treeModel.id) {
            return m.treeNode.children;
          } else {
            return [];
          }
        }, function (_ref2) {
          var key = _ref2.key;
          return treeModel.getModel(key);
        });
        setScrollTop(h);
      }, 100);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);

  var onSwitch = function onSwitch(step) {
    if (totalMatchedCount <= 0) return;
    var prev = currentMatchedKeyIndex;
    var newValue;

    if (prev <= 0 && step < 0) {
      newValue = totalMatchedCount - 1;
    } else if (prev === totalMatchedCount - 1 && step > 0) {
      newValue = 0;
    } else {
      newValue = prev + step;
    }

    if (newValue === prev) return;
    switchHighLightNode(prev, newValue, totalMatchedCount);
    setCurrentMatchedKeyIndex(newValue);
  };

  var onEnter = useFreshFunction(function (e) {
    onSwitch(1);
    var onPressEnter = staticConfig.current.onPressEnter;
    onPressEnter && onPressEnter(e);
  });
  var staticConfig = useFreshStaticValue({
    autoExpandAfterSearching: autoExpandAfterSearching,
    ignoreCase: ignoreCase,
    debounceTime: debounceTime,
    disabled: disabled,
    onSearch: onSearch,
    onPressEnter: onPressEnter,
    newSearchMethod: newSearchMethod
  });
  var searchTreeContext = React.useMemo(function () {
    return createSearchTreeModel();
  }, []); // cleanup

  React.useEffect(function () {
    searchTreeContext.search = search;
    return function () {
      searchTreeContext.search = noop;
    };
  }, [search, searchTreeContext]);
  React.useImperativeHandle(ref, function () {
    return {
      treeRef: treeRef,
      inputRef: inputRef,
      refresh: function () {
        var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt("return", new Promise(function (resolve) {
                    requestAnimationFrame(function () {
                      search();
                      resolve();
                    });
                  }));

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function refresh() {
          return _refresh.apply(this, arguments);
        }

        return refresh;
      }()
    };
  });
  React.useEffect(function () {
    setInputValue(String(value !== null && value !== void 0 ? value : ''));
  }, [value]);
  useOnUpdate(function () {
    clearTimeout(searchTreeContext.lastSearchTime);
    searchTreeContext.lastSearchTime = setTimeout(function () {
      if (!staticConfig.current.disabled) {
        searchTreeContext.matchText = inputValue;
        searchTreeContext.matched = {};
        handleSearchEvent();
      }
    }, staticConfig.current.debounceTime);
    return function () {
      clearTimeout(searchTreeContext.lastSearchTime);
    };
  }, [treeData, inputValue]);
  useOnUpdate(function () {
    var _treeRef$current, _treeRef$current$cont;

    var treeEl = (_treeRef$current = treeRef.current) === null || _treeRef$current === void 0 ? void 0 : (_treeRef$current$cont = _treeRef$current.contentEl) === null || _treeRef$current$cont === void 0 ? void 0 : _treeRef$current$cont.current;

    if (treeEl) {
      treeEl.scrollTo({
        // 居中
        top: scrollTop - treeEl.getBoundingClientRect().height / 2
      });
    }
  }, [scrollTop]);
  var style = React.useMemo(function () {
    return searchTreeStyle(theme);
  }, [theme]);
  var treeStyle = React.useRef(_treeStyle); // eslint-disable-next-line eqeqeq

  if (treeStyle.current.width == undefined) {
    treeStyle.current.width = '100%';
  }

  if (treeStyle.current !== _treeStyle) {
    treeStyle.current = Object.assign({
      width: '100%'
    }, treeStyle.current, _treeStyle);
  }

  var suffixNode = function suffixNode() {
    return !inputValue || totalMatchedCount === -1 ? /*#__PURE__*/React.createElement(SearchOutlinedIcon, null) : !shouldShowEmpty && /*#__PURE__*/React.createElement("span", {
      className: searchTreeClass('-search-matched-wrapper')()
    }, /*#__PURE__*/React.createElement("span", {
      className: searchTreeClass('-search-matched-count')()
    }, currentMatchedKeyIndex + 1, "/", totalMatchedCount), /*#__PURE__*/React.createElement("span", {
      className: searchTreeClass('-search-arrow-icon')()
    }, /*#__PURE__*/React.createElement(ArrowUpOutlinedIcon, {
      onClick: function onClick() {
        return onSwitch(-1);
      },
      className: "icon"
    }), /*#__PURE__*/React.createElement(ArrowUpOutlinedIcon, {
      onClick: function onClick() {
        return onSwitch(1);
      },
      className: "arrow-up-outlined-icon icon"
    })));
  };

  var shouldShowEmpty = Boolean(emptyContent && !staticConfig.current.disabled && inputValue && totalMatchedCount === 0);
  return /*#__PURE__*/React.createElement("div", {
    className: cx(style, "".concat(searchTreeClass("wrapper-".concat(size))()), customClass),
    style: Object.assign({
      minWidth: '320px'
    }, _style)
  }, /*#__PURE__*/React.createElement(Input, _extends({
    disabled: disabled,
    placeholder: placeholder,
    value: inputValue,
    maxLength: maxLength,
    status: status,
    onKeyDown: onKeyDown,
    onPressEnter: onEnter,
    onFocus: onFocus,
    onBlur: onBlur,
    prefix: prefix,
    size: size,
    fullWidth: true,
    clearBeforeSlot: suffixNode(),
    clearable: true,
    onChange: onChange
  }, inputProps, {
    ref: inputRef
  })), /*#__PURE__*/React.createElement("div", {
    className: dividingLine()
  }), /*#__PURE__*/React.createElement(SearchTreeContext.Provider, {
    value: searchTreeContext
  }, /*#__PURE__*/React.createElement(Tree, {
    className: cx(_defineProperty({}, hideClass(), shouldShowEmpty)),
    ref: treeRef,
    lazy: lazy,
    noStyle: true,
    defaultCheckedKeys: defaultCheckedKeys,
    checkedKeys: checkedKeys,
    selectedKeys: selectedKeys,
    defaultSelectedKeys: defaultSelectedKeys,
    defaultExpandAll: defaultExpandAll,
    defaultExpandedKeys: defaultExpandedKeys,
    disabled: disabled,
    showLine: showLine,
    showIcon: showIcon,
    checkable: checkable,
    strict: strict,
    onExpand: onExpand,
    onSelect: onSelect,
    onNodeClick: onNodeClick,
    style: treeStyle.current,
    size: size,
    treeData: treeData,
    onCheck: onCheck,
    header: header,
    multiple: multiple,
    expandAnimation: expandAnimation,
    useEllipsis: useEllipsis,
    customFooter: customFooter
  }), shouldShowEmpty && /*#__PURE__*/React.createElement(EmptyContent, {
    message: emptyContent,
    size: size
  })));
});
SearchTree.defaultProps = {
  size: 'medium',
  autoExpandAfterSearching: false,
  ignoreCase: false,
  value: '',
  treeStyle: {
    width: '100%'
  },
  debounceTime: 0,
  disabled: false,
  newSearchMethod: false
};
SearchTree.displayName = 'SearchTree';
export default /*#__PURE__*/React.memo(SearchTree);